import React from "react";
import { Route } from "react-router-dom";
import CartPriceCard from "./CartPrice";
import { CartPriceUIProvider } from "./CartPriceUIContext";
import { CartPriceDeleteDialog } from "./price-dialog/CartPriceDeleteDialog";

export function CartPricePage({ history }) {
  
  const priceUIEvents = {
    newPriceButtonClick: () => {
      history.push(`/app/cart-price/new`);
    },
    openEditPricePage: (id) => {
      history.push(`/app/cart-price/${id}/edit`);
    },
    openDeletePriceDialog: (id) => {
      history.push(`/cart-price/${id}/delete`);
    },
  };

  return (
    <CartPriceUIProvider priceUIEvents={priceUIEvents}>
      <Route exact path={`/cart-price/:id/delete`}>
        {({ history, match }) => {
          return (
            <CartPriceDeleteDialog
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(`/cart-price`);
              }}
            />
          );
        }}
      </Route>
      <CartPriceCard />
    </CartPriceUIProvider>
  );
}
